import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, useMediaQuery, useTheme } from '@mui/material'
import React, { memo, useEffect, useMemo, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import Header from '../../../components/Header'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { tokens } from '../../../theme';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { deleteDispatchSuggestion, getDispatchSuggestion } from '../../../redux/slice/dispatchsuggestion.slice';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import { getProcesscategory, getProcesssubcategory } from '../../../redux/slice/dispatchProcess.slice';

const DispatchSuggestionData = memo(({ data, columns }) => {
    return (
        <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            getRowId={(row) => row._id}
            autoHeight
            density="compact"
            getRowHeight={() => 'auto'}
            sx={{
                "@media print": {
                    "& .MuiDataGrid-toolbarContainer": {
                        display: "none !important"
                    },
                    "& .MuiDataGrid-root": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-cell": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: "black !important",
                    },
                    "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                        color: "black !important",
                    },
                },
                '& .MuiDataGrid-cell': {
                    py: '8px',
                },
            }}
        />
    );
});

const DispatchSuggestion = () => {

    const navigate = useNavigate();
    const theme = useTheme();
    const dispatch = useDispatch();
    const colors = tokens(theme.palette.mode);
    const suggestiondata = useSelector(state => state.dispatchsuggestion.dispatchsuggestion)
    const isMobile = useMediaQuery('(max-width:500px)');

    



    useEffect(() => {
        dispatch(getDispatchSuggestion())
    }, [])

    const handleDispatchSuggestion = () => {
        navigate('/admin/add-dispatch-suggestion')
    }

    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteDispatchSuggestionData, setDeleteDispatchSuggestionData] = useState(null);

    const handleDelete = (id) => {
        setDeleteDispatchSuggestionData(id);
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        if (deleteDispatchSuggestionData) {
            dispatch(deleteDispatchSuggestion(deleteDispatchSuggestionData));
            setDeleteConfirmOpen(false);
            setDeleteDispatchSuggestionData(null);
            dispatch(getDispatchSuggestion());
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteDispatchSuggestionData(null);
    }

    const handleEdit = (data) => {
        navigate('/admin/add-dispatch-suggestion', { state: data });
        dispatch(getDispatchSuggestion());
    };




    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [openView, setOpenView] = React.useState(false);
    const [viewData, setViewData] = useState(null);

    const handleClickOpenView = () => {
        setOpenView(true);
    };
    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleView = (data) => {
        handleClickOpenView();
        setViewData(data)
    }
    const columns = useMemo(() => [
        { field: 'ProjectName', headerName: 'Project Name', width: 150, filterable: true },
        {
            field: 'DispatchCatogory',
            headerName: 'Category',
            width: 190,
            filterable: true,
            valueGetter: (params) => {
                return params.row.DispatchDetails?.map(detail =>
                    detail?.categoryData?.categoryName || 'N/A'
                ).join(', ');
            },
            renderCell: (params) => (
                <div>
                    {params.row.DispatchDetails?.map((detail, index) => (
                        <div key={index}>{detail?.categoryData?.categoryName.length <= 25 ? detail?.categoryData?.categoryName || 'N/A' : detail?.categoryData?.categoryName + "..."}</div>
                    ))}
                </div>
            )
        },
        {
            field: 'DispatchSubCatogory',
            headerName: 'Subcategory',
            width: 190,
            filterable: true,
            valueGetter: (params) => {
                return params.row.DispatchDetails?.map(detail =>
                    detail?.subCategoryData?.subCategoryName || 'N/A'
                ).join(', ');
            },
            renderCell: (params) => (
                <div>
                    {params.row.DispatchDetails?.map((detail, index) => (
                        <div key={index}>{detail?.subCategoryData?.subCategoryName.length <= 25 ? detail?.subCategoryData?.subCategoryName || 'N/A' : detail?.subCategoryData?.subCategoryName + "..."}</div>
                    ))}
                </div>
            )
        },
        {
            field: 'DispatchProductName',
            headerName: 'Product Name',
            width: 300,
            filterable: true,
            valueGetter: (params) => {
                // 

                // const xx = params.row.DispatchDetails?.map(detail =>
                //     // 

                //     detail?.productData?.productName ? detail?.productData?.productName : detail?.kitData?.KitName
                // )

                // 


                return params.row.DispatchDetails?.map(detail =>
                    detail?.productData?.productName ? detail?.productData?.productName : detail?.kitData?.KitName
                ).join(', ');
            },
            renderCell: (params) => (
                <div>
                    {params.row.DispatchDetails?.map((detail, index) => (
                        <div key={index}>{detail?.productData?.productName.length <= 38 || detail?.kitData?.KitName.length <= 38 ? detail?.productData?.productName || detail?.kitData?.KitName || 'N/A' : detail?.productData?.productName ? detail?.productData?.productName || 'N/A' + "..." : 'N/A'}</div>
                    ))}
                </div>
            )
        },
        {
            field: 'DispatchDiscription', headerName: 'Description', width: 450,
            renderCell: (params) => {
                return (
                    // <div>
                    //     {params.row.DispatchDetails?.map(detail => detail.DispatchDiscription)
                    //         .map((des, index) => (
                    //             des && <div key={index}>{des}</div> || 'N/A'
                    //         ))}
                    // </div>

                    <div>
                        {params.row.DispatchDetails?.map((detail, index) => (
                            <div key={index}>{detail?.productData?.Desacription.length <= 38 ? detail?.productData?.Desacription || 'N/A' : detail?.productData?.Desacription ? detail?.productData?.Desacription + "..." : 'N/A'}</div>
                        ))}
                    </div>
                );
            }
        },
        {
            field: 'DispatchUnit', headerName: 'Unit', width: 100, filterable: true,
            valueGetter: (params) => params.row.DispatchDetails?.map(detail => detail.DispatchUnit).join(', '),
            renderCell: (params) => (
                <div>
                    {params.row.DispatchDetails?.map((detail, index) => (
                        <div key={index}>{detail?.productData?.unitOfMeasurement.length <= 38 ? detail?.productData?.unitOfMeasurement || 'N/A' : detail?.productData?.unitOfMeasurement ? detail?.productData?.unitOfMeasurement + "..." : 'N/A'}</div>
                    ))}
                </div>
            )
        },
        {
            field: 'DispatchQty', headerName: 'Qty', width: 80, filterable: true,
            valueGetter: (params) => params.row.DispatchDetails?.map(detail => detail.DispatchQty).join(', '),
            renderCell: (params) => (
                <div>
                    {params.row.DispatchDetails?.map(detail => detail.DispatchQty)
                        .map((item, index) => (
                            item && <div key={index}>{item}</div> || '1'
                        ))}
                </div>
            )
        },
        {
            field: 'Action',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => (
                <>
                    <IconButton aria-label="view"
                        onClick={() => handleView(params.row)}
                    >
                        <RemoveRedEyeIcon />
                    </IconButton>
                    <IconButton aria-label="edit"
                        onClick={() => handleEdit(params.row)}
                    >
                        <EditIcon />
                    </IconButton>
                    <IconButton aria-label="delete"
                        onClick={() => handleDelete(params.row._id)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </>
            )
        }
    ], []);

    


    return (
        <Box m="2px">
            <Header
                title="DISPATCH SUGGESTION"
                subtitle="Manage Your Dispatch Suggestion Here"
            />
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleDispatchSuggestion}>
                    Add Dispatch Suggestion
                </Button>
            </Box>

            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important",
                    },
                }), [colors])}
            >
                <DispatchSuggestionData data={suggestiondata} columns={columns} />
            </Box>

            <Dialog
                fullScreen={fullScreen}
                open={openView}
                onClose={handleCloseView}
                aria-labelledby="responsive-dialog-title"
                maxWidth={"sm"}
                fullWidth
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: "center", fontWeight: 'bold', fontSize: '18px' }}>
                    {"Dispatch Suggestion Details"}
                </DialogTitle>
                <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ flex: '1' }}>
                            <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Project Name:</strong> {viewData?.ProjectName}</p>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ flex: '1' }}>
                            <h3>Dispatch Details:</h3>
                            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                                <thead>
                                    <tr>
                                        <th style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>Category</th>
                                        <th style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>Subcategory</th>
                                        <th style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>Product Name</th>
                                        <th style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>Description</th>
                                        <th style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>Unit</th>
                                        <th style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {viewData?.DispatchDetails?.map((Dispatch, index) => (
                                        <tr key={index}>
                                            <td style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>
                                                {Dispatch.categoryData?.categoryName || 'N/A'}
                                            </td>
                                            <td style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>
                                                {Dispatch.subCategoryData?.subCategoryName || 'N/A'}
                                            </td>
                                            <td style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>
                                                {Dispatch?.productData?.productName ? Dispatch?.productData?.productName : Dispatch?.kitData?.KitName}
                                            </td>
                                            <td style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>
                                                {Dispatch.DispatchDiscription || 'N/A'}
                                            </td>
                                            <td style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>
                                                {Dispatch.DispatchUnit || 'N/A'}
                                            </td>
                                            <td style={{ padding: '10px', borderBottom: `1px solid ${colors.grey[100]}` }}>
                                                {Dispatch.DispatchQty || '1'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                    <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }} >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this Dispatch Suggestion?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>

        </Box >
    )
}

export default DispatchSuggestion
